import { useState } from 'react'
import type { UIEvent } from 'react'

const IS_SCROLL_AREA_HEIGHT = 300

/**
 * 현재 요소(페이지)가 화면 최하단까지 스크롤이 되었는지 확인하는 hook
 * @returns [boolean, Dispatch<SetStateAction<boolean>>, (e: UIEvent<HTMLElement>) => void, (scrollHeight: number, clientHeight: number) => void]
 */
export function useScrollToBottom() {
  const [isScrollBottom, setIsScrollBottom] = useState<boolean>(false)

  const checkScrollToBottom = ({ currentTarget: { clientHeight, scrollHeight, scrollTop } }: UIEvent<HTMLElement>) => {
    if (isScrollBottom) {
      return
    }

    if (scrollTop + clientHeight + IS_SCROLL_AREA_HEIGHT >= scrollHeight) {
      setIsScrollBottom(true)
    }
  }

  const checkDidMountScrollHeight = (scrollHeight: number, clientHeight: number) => {
    if (scrollHeight - IS_SCROLL_AREA_HEIGHT <= clientHeight) {
      setIsScrollBottom(true)
    }
  }

  return { isScrollBottom, setIsScrollBottom, checkScrollToBottom, checkDidMountScrollHeight }
}
